var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGzIdentityCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 41.67V50H56.67l7.68-14.59A6.55 6.55 0 0169 41.67zM59.28 29l-3.12 6H38a6.88 6.88 0 00-7 6.73V50h17.75l-4.17 8H48l13.3-26H69v-3h-9.72zm-14.92-.22a7.34 7.34 0 10-1.11-2 6.998 6.998 0 001.11 2zM14.15 17.2a32.55 32.55 0 018 21.44 32.55 32.55 0 01-8 21.44l3 2.64a36.58 36.58 0 009-24.08 36.53 36.53 0 00-9-24.07l-3 2.63zM12.57 21L9.4 23.43a24.67 24.67 0 015.18 15.21A24.72 24.72 0 019.4 53.86l3.17 2.44a28.69 28.69 0 006-17.66 28.69 28.69 0 00-6-17.64zm-3.36 8l-3.59 1.76a17.57 17.57 0 011.83 7.88 17.57 17.57 0 01-1.83 7.88l3.59 1.77a21.6 21.6 0 002.24-9.65A21.6 21.6 0 009.21 29z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/GZ_Identity_check.c348fbe3.svg";
export { SvgGzIdentityCheck as ReactComponent };